import type { Dispatch, SetStateAction } from "react";
import { useState } from "react";

import type { OnboardingGoalQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";
import { redirectUserByGoal } from "app/pages/sales-intelligence/sub-modules/onboarding/utils/redirectUserByGoal";

interface Result {
    redirect: () => void;
    setGoal: Dispatch<SetStateAction<OnboardingGoalQuestionType>>;
}

function useRedirectionByGoal(): Result {
    const [goal, setGoal] = useState<OnboardingGoalQuestionType>();

    const redirect = () => {
        redirectUserByGoal(goal);
    };

    return { redirect, setGoal };
}

export default useRedirectionByGoal;
